import React from 'react';
import { Card as AntDCard, CardProps } from 'antd';
import classNames from 'classnames';

import { Maybe } from 'types';
import { OcEnterprise } from 'Illustrations';
import './index.less';

type Size = 'default' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';

export interface Props extends CardProps {
  variant: 'primary' | 'tertiary';
  illustration?: Partial<Record<string, React.ElementType>>;
}

export default function Custom({
  children,
  variant,
  illustration = {
    'tw-hidden md:tw-block': OcEnterprise,
  },
  size = 'default',
  className = '',
  bodyStyle = {},
  ...props
}: Props) {
  const ref = React.useRef<HTMLDivElement>();

  return (
    <AntDCard
      className={classNames(
        'sl-card tw-shadow-primary-xl hover:tw-shadow-primary-2xl tw-relative',
        {
          'tw-bg-primary hover:tw-bg-primary-600 tw-text-white': variant === 'primary',
          'tw-bg-primary-100 hover:tw-bg-primary-200 tw-text-primary-800': variant === 'tertiary',
        },
        className
      )}
      size={size}
      headStyle={{
        fontWeight: 'normal',
        fontSize: 12,
        minHeight: 0,
        lineHeight: '16px',
        textTransform: 'uppercase',
        color: '#A38DE2',
      }}
      bodyStyle={{
        ...bodyStyle,
        display: 'flex',
        flexGrow: 1,
        minHeight: 0,
        paddingTop: 8,
      }}
      {...{
        ref: (node: Maybe<HTMLDivElement>) => {
          if (node instanceof HTMLDivElement) {
            ref.current = node;
          }
        },
      }}
      {...props}
    >
      {children}
      <div
        className={classNames('tw-absolute tw-z-0 tw-bottom-0', {
          'tw-right-4': size === 'small',
          'tw-right-6': size !== 'small',
        })}
      >
        {Object.keys(illustration).map((key, idx) => {
          const Component = illustration[key as Size] as React.ElementType;

          return (
            <Component
              key={idx}
              color={variant === 'primary' ? 'white' : '#211249'}
              className={classNames(key)}
            />
          );
        })}
      </div>
    </AntDCard>
  );
}
